import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

function FeatureCard({ icon, title, description }) {
  return (
    <Card
      variant="outlined"
      sx={{
        minHeight: 220,
        transition: 'transform 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 6,
        },
      }}
    >
      <CardContent sx={{ textAlign: 'center' }}>
        <Box sx={{ fontSize: 48, color: 'primary.main' }}>{icon}</Box>
        <Typography variant="h6" component="div" sx={{ mt: 2, mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default FeatureCard;
